import React from 'react';
import CompanyCard from '../CompanyCard';

interface CompanyListViewProps {
  companies: any[];
  onCompanyClick: (index: number) => void;
  onEditClick: (slug: string) => void;
  scrapbookEntries: any[];
  onScrapbookUpdate: () => void;
}

const CompanyListView = ({
  companies,
  onCompanyClick,
  onEditClick,
  scrapbookEntries,
  onScrapbookUpdate
}: CompanyListViewProps) => {
  // Debug the first few companies
  if (companies.length > 0) {
    const debugCompanies = companies.filter(c =>
      c.slug === 'notion' || c.slug === 'shopify' || c.slug === 'github'
    );

    if (debugCompanies.length > 0) {
      console.log('🔍 [CompanyListView] Debug companies:',
        debugCompanies.map(c => ({
          slug: c.slug,
          hasTags: Boolean(c.tags && c.tags.length > 0),
          tags: c.tags ? c.tags.map(tag => {
            if (typeof tag === 'string') return tag;
            if (tag?.name) return tag.name;
            if (tag?.tag?.name) return tag.tag.name;
            return JSON.stringify(tag);
          }) : []
        }))
      );
    }
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {companies.map((company, index) => {
        // Ensure tags is always an array
        const companyWithTags = {
          ...company,
          tags: Array.isArray(company.tags) ? company.tags : []
        };

        return (
          <CompanyCard
            key={company.slug}
            {...companyWithTags}
            onClick={() => onCompanyClick(index)}
            onEditClick={onEditClick}
            scrapbookEntries={scrapbookEntries}
            onScrapbookUpdate={onScrapbookUpdate}
            beforeUrl={company.beforeUrl}
            afterUrl={company.afterUrl}
            pricingMetrics={company.pricingMetrics || []}
            pages={company.pages || []}
          />
        );
      })}
    </div>
  );
};

export default CompanyListView;